import YoutubeEmbed from '@core/components/YoutubeEmbed/YoutubeEmbed';
import { Button, Grid, makeStyles } from '@material-ui/core';
import React, { useContext } from 'react';
import { OnboardingContext } from '../OnboardingContext';
import OnboardingLayout from '../OnboardingLayout';

const useStyles = makeStyles(() => ({
  cabecalho: {
    textAlign: 'right',
    marginTop: '5%',
  },
  titulo: {
    fontSize: '36px',
    fontWeight: '800',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.11,
    letterSpacing: 'normal',
    textAlign: 'right',
    color: '#2e62b8',
  },
  logoFatureMais: {
    width: '200px',
  },
  logoGroupFinanceiro: {
    width: '164px',
  },
  btnAvancar: {
    borderRadius: '48px',
    textTransform: 'capitalize',
    backgroundColor: '#2e62b8',
    width: '100%',
    marginTop: '5%',
  },
}));

const ApresentacaoOnboarding = () => {
  const classes = useStyles(useStyles);

  const [, setEtapa] = useContext(OnboardingContext).etapa;

  const btnQueroComecar = () => {
    setEtapa('DADOS_CADASTRAIS');
  };

  return (
    <OnboardingLayout
      content={
        <>
          <div style={{ flex: '1 0 auto' }}>
            <Grid container>
              <Grid item lg={10} md={10} sm={10} xs={10} className={classes.cabecalho}>
                <span className={classes.titulo}>
                  A revolução no seu
                  <br /> negócio começa agora!
                </span>
              </Grid>
              <Grid item lg={2} md={2} sm={2} xs={2} />
            </Grid>
            <Grid container>
              <Grid item lg={2} md={2} sm={2} xs={false} />
              <Grid item lg={4} md={4} sm={4} xs={112} style={{ marginTop: '-2%' }}>
                <img style={{ float: 'right' }} src="assets/images/onboarding/7.svg" alt="onboarding_image" />
              </Grid>
              <Grid item lg={4} md={4} sm={4} xs={12} style={{ marginTop: '5%' }}>
                {process.env.REACT_APP_KEYCLOAK_CLIENT_ID === 'financeiro-front' ? (
                  <YoutubeEmbed embedId="LRtAEGsQONI" />
                ) : (
                  <YoutubeEmbed embedId="oP_ZNIp2uec" />
                )}
              </Grid>
              <Grid item lg={2} md={2} sm={2} xs={false} />
            </Grid>
            <Grid container>
              <Grid item lg={2} md={2} sm={2} xs={12} />
              <Grid item lg={2} md={2} sm={2} xs={6}>
                {process.env.REACT_APP_KEYCLOAK_CLIENT_ID === 'financeiro-front' ? (
                  <Grid item className={classes.logoFatureMais}>
                    <img src="assets/images/logos/fature_mais_azul.svg" alt="logo" />
                  </Grid>
                ) : (
                  <Grid item className={classes.logoGroupFinanceiro}>
                    <img src="assets/images/logos/group_financeiro_azul.png" alt="logo" />
                  </Grid>
                )}
              </Grid>
              <Grid item lg={4} md={4} sm={4} xs={false} />
              <Grid item lg={2} md={2} sm={2} xs={6}>
                <Button
                  size="large"
                  className={classes.btnAvancar}
                  title="Quero começar"
                  variant="contained"
                  color="primary"
                  onClick={btnQueroComecar}
                >
                  Quero começar
                </Button>
              </Grid>
              <Grid item lg={2} md={2} sm={2} />
            </Grid>
          </div>
        </>
      }
    />
  );
};

export default ApresentacaoOnboarding;
